import { appConfig as $config } from '../../app.config';
import { App } from '../../modules/App';
import { UI } from '../../modules/UI';
import { fUploader } from '../../modules/fUploader';
import { User } from '../User';
import { Common } from '../Common';

import { TABLE_COLUMNS } from './constants';

import './scss/assetsmanager.scss';

export const assetsManager = (function () {
  let $lang = $Lang;
  let $partType = 3,
    $targetTable,
    $pageType,
    $complete,
    $infoMode,
    $printAreaFull,
    $printAreaOptimal,
    $printAreaPocket;
  let $fup = null; // File Uploader Class
  let $ReplacedMockupsCount = null; // - FLAG Replaced Source Files
  let $skipGenerateFiles = null; // - FLAG Replaced Source Files

  let $filesPartType;
  let $filesModel;

  let mapping = {
    files: (data) => {
      let files = [];
      Object.keys($filesPartType).forEach((type) => {
        files[$filesPartType[type].name] = [];
      });

      data.forEach((file) => {
        let partType = file.partType && Number.isInteger(file.partType * 1) ? file.partType : 3;
        let partTypeName = $filesPartType[partType].name;
        file.partType = partType;
        file.partTypeName = partTypeName;

        if ($pageType == $config.folderName.artworks || $pageType == $config.folderName.artworksInfo) {
          if (partType == 2) {
            files[partTypeName].push(mapping.screenPrintFileObject(file));
          } else if (file.uri) {
            files[partTypeName].push(mapping.fileObject(file));
          }
        }

        if ($pageType == $config.folderName.trims) {
          files[partTypeName].push(mapping.fileObject(file));
        }

        if ($pageType == $config.folderName.stamps) {
          files[partTypeName].push(mapping.fileObject(file));
        }

        if ($pageType == $config.folderName.orders) {
          files[partTypeName].push(mapping.fileObject(file));
        }
      });
      return files;
    },
    addFiles: (data) => {
      let files = [];
      data.forEach((file) => {
        if (file.uri || file.url || (file.partType && file.partType == 2)) {
          file.partType = file.partType || $partType;
          if ($pageType == $config.folderName.artworks) {
            if (file.partType == 2) {
              //'ScreenPrint'
              files.push(mapping.screenPrintFileObject(file));
            } else {
              files.push(mapping.fileObject(file));
            }
          }

          if ($pageType == $config.folderName.trims) {
            files.push(mapping.fileObject(file));
          }

          if ($pageType == $config.folderName.stamps) {
            files.push(mapping.fileObject(file));
          }

          if ($pageType == $config.folderName.orders) {
            files.push(mapping.fileObject(file));
          }
        }
      });
      return files;
    },
    fileObject: (file) => {
      if (!file.fileName && !file.name) {
        return {};
      }
      let id = file.id ? file.id : file.fileStorageName ? file.fileStorageName.split('.')[0] : Common._uuidv4();
      return {
        partType: file.partType,
        partTypeName: file.partTypeName,
        id: id,
        DT_RowId: id,
        url: file.url ? file.url : file.uri,
        thumbnail: file.thumbnail ? file.thumbnail : file.thumbnailImageUri ? file.thumbnailImageUri : file.uri,
        type: file.type != undefined ? file.type : file.fileType,
        name: file.name ? file.name : file.fileName,
        fileStorageName: file.fileStorageName,
        size: file.size ? file.size : '',
        size2: file.size2 ? file.size2 : '',
        resolution: file.resolution ? file.resolution : '',
        additionalValues: file.additionalValues ? file.additionalValues : {},
        thumbnailImageUri: file.thumbnailImageUri || null,
        IsAdd: file.IsAdd || false,
        notificationStatus: file.notificationStatus ? file.notificationStatus : null
      };
    },
    screenPrintFileObject: (obj = null) => {
      let uuid = Common._uuidv4();
      return {
        partType: obj ? obj.partType : 2,
        partTypeName: obj ? obj.partTypeName : $filesPartType['2'].name,
        id: obj ? obj.id : uuid,
        DT_RowId: obj ? obj.id : uuid,
        fileType: obj ? obj.fileType : 15,
        pantoneName: obj ? obj.pantoneName : '',
        colorPallete: obj ? mapping.colorPallete(obj.colorPallete) : { Cyan: '', Magenta: '', Yellow: '', Key: '' },
        coloredFile: obj
          ? Array.isArray(obj.coloredFile) && obj.coloredFile.length
            ? mapping.fileObject(obj.coloredFile[0])
            : Object.keys(obj.coloredFile).length
            ? mapping.fileObject(obj.coloredFile)
            : {}
          : {},
        negativeFile: obj
          ? Array.isArray(obj.negativeFile) && obj.negativeFile.length
            ? mapping.fileObject(obj.negativeFile[0])
            : Object.keys(obj.negativeFile).length
            ? mapping.fileObject(obj.negativeFile)
            : {}
          : {},
        order: obj
          ? obj.order
          : window['screenPrintData']?.files?.length
          ? window['screenPrintData'].files.length + 1
          : 1,
        url: obj ? obj.url : true
      };
    },
    filesSelectList: (files, printMethodTab = false) => {
      let selectList = $.extend(true, [], $filesModel);
      let flag = false,
        selectedElem;

      selectList.sort(function (a, b) {
        return a.order - b.order;
      });
      selectList.forEach((elem) => {
        let exist = _.findWhere(files, { type: elem.fileType });
        if (!exist && !flag && !elem.auto) {
          elem.selected = true;
          selectedElem = elem;
          flag = true;
        }
      });

      if (printMethodTab == 'ScreenPrint' && selectList[0].selected) {
        selectList[0].selected = false;
        selectList[1].selected = true;
      }

      return selectList;
    },
    originalFiles: (data) => {
      let newArr = [];
      data.forEach((file) => {
        let obj;
        if (file.partType == 2) {
          obj = {
            partType: file.partType,
            fileType: file.fileType,
            id: file.id,
            pantoneName: file.pantoneName,
            colorPallete: mapping.originalColorPallete(file.colorPallete),
            coloredFile: Object.keys(file.coloredFile).length
              ? mapping.originalFilesObject(file.coloredFile, file.partType)
              : {},
            negativeFile: Object.keys(file.negativeFile).length
              ? mapping.originalFilesObject(file.negativeFile, file.partType)
              : {},
            order: file.order
          };
        } else {
          obj = mapping.originalFilesObject(file);
        }
        newArr.push(obj);
      });
      return newArr;
    },
    originalFilesObject: (file, partType = false) => {
      return {
        partType: partType ? partType : file.partType,
        fileName: file.name,
        fileStorageName: file.fileStorageName,
        folderName: $pageType,
        containerName: User.accountID(),
        uri: file.url,
        fileType: file.type,
        additionalValues: file.additionalValues ? file.additionalValues : {},
        thumbnailImageUri: file.thumbnailImageUri || null,
        IsAdd: file.IsAdd
      };
    },
    colorPallete: (data) => {
      return {
        Cyan: data.Cyan ? data.Cyan * 1 : data.cyan ? data.cyan * 1 : '',
        Magenta: data.Magenta ? data.Magenta * 1 : data.magenta ? data.magenta * 1 : '',
        Yellow: data.Yellow ? data.Yellow * 1 : data.yellow ? data.yellow * 1 : '',
        Key: data.Key ? data.Key * 1 : data.key ? data.key * 1 : ''
      };
    },
    originalColorPallete: (data) => {
      return {
        cyan: data.Cyan != '' ? data.Cyan * 1 : 0,
        magenta: data.Magenta != '' ? data.Magenta * 1 : 0,
        yellow: data.Yellow != '' ? data.Yellow * 1 : 0,
        key: data.Key != '' ? data.Key * 1 : 0
      };
    },
    areaSize: (data) => {
      return {
        width: data.Width,
        height: data.Height
      };
    }
  };

  let init = ({
    files = [],
    checkedPartTypes = 0,
    pageType = false,
    infoMode = false,
    areaSizes = [],
    update = () => {}
  } = {}) => {
    $pageType = pageType;
    $infoMode = infoMode;
    $complete = update;
    $printAreaFull = areaSizes.length
      ? mapping.areaSize(areaSizes.find((area) => area.AreaType == $config.areasType.full))
      : {};
    $printAreaOptimal = areaSizes.length
      ? mapping.areaSize(areaSizes.find((area) => area.AreaType == $config.areasType.optimal))
      : {};
    $printAreaPocket = areaSizes.length
      ? mapping.areaSize(areaSizes.find((area) => area.AreaType == $config.areasType.pocket))
      : {};

    $filesModel = $config.filesModel;
    $filesPartType = $config.filesPartType;

    // Check checkedPartTypes
    $('input[type="checkbox"].checkedPartTypes').each(function () {
      $(this)
        .prop('checked', (checkedPartTypes & $(this).data('parttype')) == $(this).data('parttype'))
        .on('change', () => {
          $complete(getFiles());
        });
    });

    let data = mapping.files(files);
    for (let part in data) {
      if ($(`table[data-part="${part}"]`).length) {
        DTable(`table[data-part="${part}"]`, data[part], part);
      }
    }

    clickHandler();

    return assetsManager;
  };

  let DTable = (elem, dataSet, part) => {
    const printAreas = { $printAreaFull, $printAreaOptimal, $printAreaPocket };

    let columns = TABLE_COLUMNS.sourceFilesColumns(printAreas);

    if ($pageType == $config.folderName.artworks || $pageType == $config.folderName.artworksInfo) {
      if (part == 'ScreenPrint') {
        columns = TABLE_COLUMNS.screenPrintFilesColumns($infoMode);
      }
    }
    if ($pageType == $config.folderName.trims) {
      columns = TABLE_COLUMNS.trimColumns(printAreas);
    }

    if ($pageType == $config.folderName.stamps) {
      columns = TABLE_COLUMNS.stampColumns(printAreas);
    }

    columns = $.extend(true, [], columns);

    if ($infoMode) {
      columns.splice(columns.length - 1, 1);
    }

    $(elem)
      .DataTable({
        columns: columns,
        data: dataSet,
        rowReorder: part == 'ScreenPrint' && !$infoMode ? { selector: 'td.reorder-arrows', dataSrc: 'order' } : false,
        order: part == 'ScreenPrint' && !$infoMode ? [2, 'asc'] : [],
        responsive: {
          details: {
            type: 'column',
            target: 0
          }
        },
        pageLength: 100,
        cache: false,
        searching: false,
        dom: '<"row"<"col-sm-12"t>>', //<"row"<"col"B>>
        drawCallback: () => {
          UI.unblock('#page');
          // Image popup
          $('.magnific-image').magnificPopup({ type: 'image' });
        },
        initComplete: () => {}
      })
      .on('row-reorder', function (e, diff, edit) {
        if (!$infoMode) {
          $complete(getFiles());
        }
      });
  };

  let clickHandler = () => {
    $('.assets-files-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      $(window).trigger('resize');
    });

    $('#artworkDialogForm')
      .on('click', '.js-action-addAssetsFile', addAssetsFileDialog)
      .on('click', '.js-action-RemoveAssetsFile', removeAssetsFileDialog);

    $('#trimDialogForm')
      .on('click', '.js-action-addAssetsFile', addTrimsFileDialog)
      .on('click', '.js-action-RemoveAssetsFile', removeAssetsFileDialog);

    $('#stampDialogForm')
      .on('click', '.js-action-addAssetsFile', addStampsFileDialog)
      .on('click', '.js-action-RemoveAssetsFile', removeAssetsFileDialog);

    $('body').on('keypress change', 'input[type="number"].js-max-number-100', (e) => {
      let val = $(e.target).val();
      if (/[0-9]/.test(String.fromCharCode(e.which))) {
        if ((val + '' + String.fromCharCode(e.which)) * 1 > 100) {
          return e.preventDefault();
        }
      }
      return (
        e.metaKey || // cmd/ctrl
        e.which <= 0 || // arrow keys
        e.which == 8 || // delete key
        /[0-9]/.test(String.fromCharCode(e.which))
      );
    });
  };

  let addAssetsFileDialog = (e) => {
    let target = $(e.target).is('button') ? $(e.target) : $(e.target).closest('button');

    let partName = target.data('partname');
    $targetTable = `table[data-part="${partName}"]`;
    $partType = partTypeFromName(partName);

    if (!$($targetTable).length) {
      return alert('Table not found');
    }

    // Screen Print Files
    if ($partType == 2) {
      //'ScreenPrint'
      return screenPrintFilesDialog();
    }

    sourceFilesDialog();
  };

  let sourceFilesDialog = () => {
    let printMethodTab = $('.artwork-assets-tab-pane:visible').attr('id').replace('Tab', '');

    let data = {
      filesSelectList: mapping.filesSelectList(getPartFiles(), printMethodTab), // Set selected option by existing files
      $lang: $Lang
    };
    let template = require('./tmpl/dialog/addfile.hbs');
    bootbox
      .dialog({
        title: $lang.assetsManager.Addartworkfile,
        message: template(data),
        size: 'large',
        className: 'modal-scrolled-content assets-manager-addfile',
        buttons: {
          ok: {
            label: $lang.btn.save,
            className: 'btn btn-brand',
            callback: validateUploadSourceFile
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(sourceFilesDialogInit);
  };

  let sourceFilesDialogInit = () => {
    $('#addFileFileType-select').select2().on('change', fileTypeSwith).trigger('change');
  };

  let fileTypeSwith = (e) => {
    let letter = $(e.target).val() * 1;

    if (letter < 0) {
      $fup = new fUploader('input[type="file"]', { disabled: true });
      $('#filesRequirements').empty();
      return;
    }

    $('#filesRequirements').html($lang.filesModel[letter].requirements);
    validateNotification();

    $fup = new fUploader('input[type="file"]', {
      ...$filesModel[letter],
      ...{
        pageType: $pageType,
        blockEl: '.assets-manager-addfile .modal-content',
        validate: (data) => {
          validateNotification(letter === 1 ? data : false);
        },
        complete: uploadComplete
      }
    });
  };

  let validateNotification = (data = false) => {
    if (!data) {
      $('#notificationAlert').empty().hide();
      return;
    }
    let status = notificationFileByResolution(data);
    if (status) {
      let arr = [],
        out = '';
      if (status.isAreaFull != undefined) {
        if (!status.isAreaFull) arr.push($Lang.assetsManager.notifications.fullarea);
        if (!status.isAreaOptimal) arr.push($Lang.assetsManager.notifications.optimalarea);
        if (!status.isAreaPocket) arr.push($Lang.assetsManager.notifications.pocketarea);
        out = arr.length
          ? $Lang.assetsManager.notifications.doesnt + arr.join(', ') + $Lang.assetsManager.notifications.canvassize
          : '';
      }
      if (out != '') {
        $('#notificationAlert').empty().html(out).show();
      }
    }
  };

  let uploadFiles = (e) => {
    if (Array.isArray($fup)) {
      $fup.forEach((fup) => {
        fup.uploadStart();
      });
    } else {
      $fup.uploadStart();
    }
    return false;
  };

  let uploadComplete = (data) => {
    if ($partType === 3) {
      // - Source Files Part

      if (fileIs.canBeSrc(data[0])) {
        // - User changed source file

        if ($skipGenerateFiles) {
          // - User choose skiping generate PNG files

          update(data, 1);
        } else {
          createFiles(data[0]).then((res) => {
            if (res.isSuccess) {
              // Set SourceFile flag in additionalValues
              data[0].additionalValues.srcFile = true;
              res.filesResult.forEach((element) => {
                data.push({ ...element, IsAdd: true, partType: 3 });
              });
              update(data, 1);
            }
          });
        }

        return;
      }
    }

    update(data);
  };

  let update = (data, srcfile = false) => {
    updateFilesData(data, srcfile);

    // Check Current Tab after adding files
    checkCurrentPrintType();

    bootbox.hideAll();

    // Complete return all Files list
    $complete(getFiles());
  };

  let validateUploadSourceFile = () => {
    $ReplacedMockupsCount = null;
    $skipGenerateFiles = null;

    const selectedFileType = $('#addFileFileType-select').val() * 1;

    const selectedModel = $filesModel[selectedFileType];

    if (!selectedModel) return;

    const canbeSrc = fileIs.canBeSrc(selectedModel);
    const existFiles = getPartFiles();
    const novalid = _.where(existFiles, { type: selectedModel.fileType });
    const outOfLimit = novalid.length && selectedModel.limit <= novalid.length;

    const hasSrcFile = existFiles.filter((file) => file.additionalValues && file.additionalValues.srcFile).length;

    if (novalid.length) {
      // If exist file - Source File
      if (novalid.length == 1 && fileIs.src(novalid[0])) {
        // Confirm overwrite Source File If exist created mockups
        sourceFileConfirmDialog(novalid[0], uploadFiles, () => {
          if (outOfLimit) {
            // Confirm overwrite files If existing uploaded one
            autoCreatedConfirmDialog(novalid[0], uploadFiles);
          }
        });

        // If exist files length
      } else if (outOfLimit) {
        // Confirm overwrite files If existing uploaded one
        autoCreatedConfirmDialog(novalid[0], uploadFiles);
      }
    } else if (hasSrcFile && canbeSrc) {
      // Confirm set file - source file
      const dialogData = {
        title: $lang.assetsManager.artwork.replaceDialog.titleFirstupload.replace(
          '%fileTypeName%',
          selectedModel.typeTitle
        ),
        regenerateRadioBtns: true
      };
      confirmDialog(dialogData, () => {
        // Not source
        if ($skipGenerateFiles) {
          uploadFiles();
        } else {
          // User want make file - source file
          sourceFileConfirmDialog({ type: selectedModel.fileType, firstOfType: true }, uploadFiles, uploadFiles);
        }
      });
    } else if (existFiles.length && canbeSrc) {
      const dialogData = {
        title: $lang.assetsManager.artwork.replaceDialog.overwritePNGtitle,
        regenerateRadioBtns: true
      };
      confirmDialog(dialogData, uploadFiles);
    } else {
      uploadFiles();
    }
    return false;
  };

  let sourceFileConfirmDialog = (file, callback = () => {}, onPass = () => {}) => {
    let artworkId = $('#artworkId').val();
    if (!artworkId) {
      return onPass();
    }
    UI.block('.assets-manager-addfile .modal-dialog');
    $.when(App.ajaxData(`artworks/relations/${artworkId}`, {}, 'GET')).done((res) => {
      UI.unblock('.assets-manager-addfile .modal-dialog');

      if (res.data && res.data.mockupsCount && res.data.mockupsCount > 0) {
        $ReplacedMockupsCount = res.data.mockupsCount;

        // Auto-created files
        const messtype = file.firstOfType
          ? 'messageFirstupload'
          : fileIs.auto(file)
          ? 'messageGenerated'
          : 'messageUploaded';
        const dialogData = {
          title: file.firstOfType
            ? $lang.assetsManager.artwork.replaceDialog.titleFirstupload.replace(
                '%fileTypeName%',
                $filesModel[file.type].typeTitle
              )
            : $lang.assetsManager.artwork.replaceDialog.title.replace(
                '%fileTypeName%',
                $filesModel[file.type].typeTitle
              ),
          message: $lang.assetsManager.artwork.replaceDialog[messtype].replace(
            '%fileTypeName%',
            $filesModel[file.type].typeTitle
          ),
          alerts: [$lang.assetsManager.artwork.replaceDialog.messageProducts.replace('%count%', res.data.mockupsCount)]
        };
        if (file.type === 1) {
          dialogData.alerts.unshift($lang.assetsManager.PNGlowregenerated);
        } else if (!file.firstOfType) {
          dialogData.regenerateRadioBtns = true;
        }

        confirmDialog(dialogData, callback);
      } else {
        onPass();
      }
    });
  };

  let autoCreatedConfirmDialog = (file, callback) => {
    const fileType = file.type;

    // Source files
    const srcFile = fileIs.canBeSrc({ fileType: fileType });

    // Auto-created files
    const messtype = fileIs.auto(file) ? 'messageGenerated' : 'messageUploaded';

    const dialogData = {
      title: $lang.assetsManager.artwork.replaceDialog.title.replace(
        '%fileTypeName%',
        $filesModel[file.type].typeTitle
      ),
      message: $lang.assetsManager.artwork.replaceDialog[messtype].replace(
        '%fileTypeName%',
        $filesModel[file.type].typeTitle
      ),
      alerts: []
    };
    if (fileType === 1) {
      dialogData.alerts.unshift($lang.assetsManager.PNGlowregenerated);
    } else if (srcFile) {
      dialogData.regenerateRadioBtns = true;
    }

    confirmDialog(dialogData, callback);
  };

  let confirmDialog = (data, callback) => {
    data.$lang = $lang;
    const template = require('./tmpl/dialog/replace-confirm.hbs');
    bootbox.dialog({
      title: data.title,
      message: template(data),
      size: 'large',
      buttons: {
        ok: {
          label: data.message ? $lang.assetsManager.Yesoverwrite : 'Continue',
          className: 'btn btn-primary',
          callback: () => {
            let regenPngInput = $('input[name="regeneratePngFiles"]:checked');
            $skipGenerateFiles = regenPngInput.length && regenPngInput.val() === 'no' ? true : null;
            callback();
          }
        },
        cancel: {
          label: $lang.btn.cancel,
          className: 'btn btn-link'
        }
      }
    });
  };

  let removeAssetsFileDialog = (e) => {
    let target = $(e.target).is('a') ? $(e.target) : $(e.target).closest('a');
    let id = target.data('id');
    let part = $filesPartType[target.data('parttype')].name;
    if (!id || !part) {
      return;
    }

    // Confirm Remove File
    let exist = getPartFiles(part);
    let file = _.findWhere(exist, { id: id });
    let fileName = file.name || file.fileName;

    UI.deleteConfirm(file.name ? `<br><b class="text-break">${fileName}</b>` : ` files`).then((yes) =>
      yes ? removeAssetsFile(id, part) : false
    );
  };

  let removeAssetsFile = (id, part) => {
    App.pageData($config.GLOBAL.UNSAVED_CHANGES, true);

    let exist = getPartFiles(part);
    let file = _.findWhere(exist, { id: id });
    exist.splice(exist.indexOf(file), 1);

    if (part == 'ScreenPrint') {
      exist.sort(function (a, b) {
        return a.order - b.order;
      });
      exist.forEach((item, idx) => {
        item.order = idx + 1;
      });
    }

    $(`table[data-part="${part}"]`).each(function () {
      $(this).DataTable().clear().rows.add(exist).draw();
    });

    $complete(getFiles());
  };

  let updateFilesData = (data, srcfile = false) => {
    let exist = [],
      order = 1;
    if ($partType != 2) {
      exist = getPartFiles();
    } else {
      // Validate Screen Print Files
      data = screenPrintFilesValidate(data);
    }

    if (srcfile) {
      // Clear CourceFile flag
      exist.forEach((file) => {
        if (file.additionalValues && file.additionalValues.srcFile) file.additionalValues.srcFile = false;
      });
      // Save Artwork -> update mockups
      App.pageData('currenteditedcontent.UpdateMockupsFiles', true);
    }

    data.forEach((file) => {
      let model = $filesModel[file.fileType];
      if (exist.length && model.limit != undefined) {
        let some = _.where(exist, { type: file.fileType });
        if (some.length && some.length >= model.limit) {
          exist.splice(exist.indexOf(some[0]), 1);
        }
      }
      if (file.partType == 2) {
        file.order = order;
        order++;
      }
      exist.push(file);
    });

    let newFiles = mapping.addFiles(exist);
    $($targetTable).each(function () {
      $(this).DataTable().clear().rows.add(newFiles).draw();
    });

    $(window).trigger('resize');
  };

  let getPartFiles = (part = false) => {
    if (part) {
      part = `table[data-part="${part}"]`;
    } else {
      part = $targetTable;
    }
    if ($(part).length > 1) {
      return $($(part)[0]).DataTable().rows().data().toArray();
    }
    return $(part).DataTable().rows().data().toArray();
  };

  let getFiles = () => {
    let files = [],
      screenPrintingFiles = [];
    Object.keys($filesPartType).forEach((type) => {
      let part = $filesPartType[type].name;
      if (type == 2) screenPrintingFiles = [...screenPrintingFiles, ...getPartFiles(part)];
      else files = [...files, ...getPartFiles(part)];
    });
    return {
      files: mapping.originalFiles(files),
      screenPrintingFiles: mapping.originalFiles(screenPrintingFiles),
      checkedPartTypes: checkedPartTypes(),

      // Count of replaced Mockups If was replaced Source file
      replacedMockupsCount: $ReplacedMockupsCount
    };
  };

  let partTypeFromName = (name) => {
    let type = 3;
    Object.keys($filesPartType).forEach((key) => {
      if (name == $filesPartType[key].name) type = $filesPartType[key].value;
    });
    return type;
  };

  let checkedPartTypes = () => {
    let partType = 0;
    $('input[type="checkbox"].checkedPartTypes:checked').each(function () {
      partType = partType + $(this).data('parttype') * 1;
    });
    return partType;
  };

  let createFiles = (src) => {
    return new Promise((resolve, reject) => {
      let isAdobeFile = src.fileType === 12 || src.fileType === 3 || src.fileType === 14;
      let data = {
        accountId: User.accountID(),
        fileUri: src.uri ? src.uri : src.url,
        fileType: src.type ? src.type : src.fileType,
        filesToCreate: isAdobeFile ? [0, 1] : [0],
        fileName: src.fileName,
        isTemp: true
      };
      UI.block('.assets-manager-addfile .modal-dialog');
      $.when(App.ajaxData('File/createFiles', data, 'POST')).done((res) => {
        UI.block('.assets-manager-addfile .modal-dialog');
        res.filesResult.forEach((fileResult) => {
          if (fileResult.additionalValues && fileResult.additionalValues.multiBoarded) {
            bootbox.dialog({
              title: data.fileName,
              message: 'Contains multiple boards. Only first board was used.',
              size: 'large',
              buttons: {
                ok: {
                  className: 'btn btn-brand'
                }
              }
            });
          }
        });
        resolve(res);
      });
    });
  };

  let checkCurrentPrintType = () => {
    $(`input[type="checkbox"][data-parttype="${getCurrentPrintType()}"].checkedPartTypes`).prop('checked', true);
  };

  let getCurrentPrintType = () => {
    return $('.artwork-assets-tab-pane.tab-pane:visible').data('printtype');
  };

  let notificationFileByResolution = (data) => {
    let notificationStatus = { isAreaFull: false, isAreaOptimal: false, isAreaPocket: false };

    let DPI = $config.filesModel[1].DPI;

    let values =
      data.reader && data.reader.width
        ? data.reader
        : data.additionalValues && data.additionalValues.width && data.additionalValues.height
        ? data.additionalValues
        : false;

    if (!values) return { isAreaFull: true, isAreaOptimal: true, isAreaPocket: true };

    if (values.width * 1 >= $printAreaFull.width * DPI || values.height * 1 >= $printAreaFull.height * DPI)
      notificationStatus.isAreaFull = true;
    if (values.width * 1 >= $printAreaOptimal.width * DPI || values.height * 1 >= $printAreaOptimal.height * DPI)
      notificationStatus.isAreaOptimal = true;
    if (values.width * 1 >= $printAreaPocket.width * DPI || values.height * 1 >= $printAreaPocket.height * DPI)
      notificationStatus.isAreaPocket = true;

    return notificationStatus;
  };

  let fileIs = {
    auto: (file) => {
      return (
        file.additionalValues &&
        file.additionalValues.description &&
        (file.additionalValues.autoGenerated || file.additionalValues.description.toLowerCase().startsWith('auto'))
      );
    },
    src: (file) => {
      return file.additionalValues && file.additionalValues.srcFile;
    },
    canBeSrc: (file) => {
      // What file types can be source file
      let srcFilesArr = [];
      Object.keys($filesModel).map(function (objectKey, index) {
        if ($filesModel[objectKey].canbesource) srcFilesArr.push($filesModel[objectKey].fileType);
      });

      return srcFilesArr.includes(file.fileType);
    }
  };

  let screenPrintFilesDialog = () => {
    let data = {
      $lang: $Lang,
      files: getPartFiles()
    };

    let template = require('./tmpl/dialog/addfile-sp.hbs');
    bootbox
      .dialog({
        title: $lang.assetsManager.Addartworkfilebychanels,
        message: template(data),
        size: 'xl',
        className: 'modal-scrolled-content assets-manager-addfile',
        buttons: {
          ok: {
            label: $lang.btn.save,
            className: 'btn btn-brand',
            callback: screenPrintFilesSave
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(() => {
        screenPrintFilesDialogInit(data);
      });
  };

  let screenPrintFilesDialogInit = (data) => {
    data = {
      ...data,
      ...{
        addPrintScreenFileDialogHandler: addPrintScreenFileDialogHandler
      }
    };

    window['screenPrintData'] = data;
    dataBinder.dataBind(document.getElementById('addscreenPrintFilesDialogContent'), window['screenPrintData']);

    addPrintScreenFileDialogHandler(true);
  };

  let addPrintScreenFileDialogHandler = (init = false) => {
    if (init && window['screenPrintData'].files.length) {
    } else {
      window['screenPrintData'].files.push(mapping.screenPrintFileObject());
    }

    setTimeout(() => {
      $('#addscreenPrintFilesDialogContent table tbody').sortable({
        axis: 'y',
        handle: '.handle'
      });

      $('#addscreenPrintFilesDialogContent input[type="file"]').each(function () {
        if (!$(this).attr('fuploader')) {
          let El = $(this)[0];
          let idx = $(this).data('idx');
          let printFileType = $(this).data('printfiletype');

          screenprintFilesDialogUploader({
            El,
            idx,
            printFileType
          });
        }
      });
    }, 30);
  };

  let screenprintFilesDialogUploader = ({ El, idx, printFileType } = {}) => {
    const uploader = new fUploader(El, {
      ...$filesModel['screenprintFiles'],
      ...{
        pageType: $pageType,
        blockEl: '.assets-manager-addfile .modal-content',
        autostart: true,
        extendParams: { idx: idx, printFileType: printFileType },
        completeOnRemove: true,
        complete: (data) => {
          if (data[0].idx === undefined || !data[0].printFileType) return;

          const file = data[0];

          UI.unblock('.assets-manager-addfile .modal-content');
          window['screenPrintData'].files[file.idx][file.printFileType] = file;
        }
      }
    });
  };

  let screenPrintFilesSave = () => {
    const files = JSON.parse(JSON.stringify(window['screenPrintData'].files));
    let newFiles = [];
    $('#addscreenPrintFilesDialogContent table .handle').each((order, el) => {
      const id = $(el).data('id');
      let file = _.findWhere(files, { id: id });
      if(file.negativeFile.uri || file.negativeFile.url){
        file.order = order + 1;
        newFiles.push(file);
      }
    });
    delete window['screenPrintData'];
    uploadComplete(newFiles);
  };

  let screenPrintFilesValidate = (data) => {
    let newData = [];
    data.forEach((file) => {
      if (!$.isEmptyObject(file.negativeFile)) {
        newData.push(file);
      }
    });
    return newData;
  };

  let addTrimsFileDialog = (e) => {
    let target = $(e.target).is('button') ? $(e.target) : $(e.target).closest('button');

    let partName = target.data('partname');
    $targetTable = `table[data-part="${partName}"]`;
    $partType = partTypeFromName(partName);

    if (!$($targetTable).length) {
      return alert('Table not found');
    }

    trimAndStampsFilesDialog(true);
  };

  let addStampsFileDialog = (e) => {
    let target = $(e.target).is('button') ? $(e.target) : $(e.target).closest('button');

    let partName = target.data('partname');
    $targetTable = `table[data-part="${partName}"]`;
    $partType = partTypeFromName(partName);

    if (!$($targetTable).length) {
      return alert('Table not found');
    }

    trimAndStampsFilesDialog(false);
  };

  let trimAndStampsFilesDialog = (isTrim) => {
    let data = {
      filesSelectList: mapping.filesSelectList(getPartFiles()), // Set selected option by existing files
      $lang: $Lang
    };
    let template = require('./tmpl/dialog/addfile.hbs');
    bootbox
      .dialog({
        title: isTrim ? $lang.assetsManager.AddTrimFile : $lang.assetsManager.AddHangtagFile,
        message: template(data),
        size: 'large',
        className: 'modal-scrolled-content assets-manager-addfile',
        buttons: {
          ok: {
            label: $lang.btn.save,
            className: 'btn btn-brand',
            callback: () => {
              App.pageData($config.GLOBAL.UNSAVED_CHANGES, true);
              return uploadFiles();
            }
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(sourceFilesDialogInit);
  };

  return {
    init,
    notificationFileByResolution,
    getFiles
  };
})();
